import { Map as MapYandex, Placemark, YMaps } from '@pbe/react-yandex-maps';
import { memo, useCallback, useEffect } from 'react';

import { useCdekWidget } from '@screens/PlacingOrder/ui/CdekWidget/CdekWidget';
import markerSelectedIcon from '@shared/assets/icons/marker-selected.svg';
import markerIcon from '@shared/assets/icons/marker.svg';
import { CdekOffice } from '@shared/types/cdek';

import cls from './Map.module.scss';

export const Map = memo(() => {
  const { open, mapRef, points, selectedPoint, onChangeSelectedPoint } = useCdekWidget() || {};

  const handleClickPoint = useCallback(
    (point: CdekOffice) => () => {
      onChangeSelectedPoint?.(point);
    },
    [onChangeSelectedPoint]
  );

  useEffect(() => {
    if (selectedPoint && open) {
      const { latitude, longitude } = selectedPoint.location;

      setTimeout(() => {
        mapRef?.current?.setCenter([latitude, longitude], 14, {
          duration: 300,
          checkZoomRange: true
        });
      }, 200);
    }
  }, [mapRef, open, selectedPoint]);

  return (
    <YMaps>
      <MapYandex
        instanceRef={mapRef}
        className={cls.map}
        defaultState={{
          center: [55.751244, 37.618423],
          zoom: 9,
          controls: ['zoomControl']
        }}
        modules={['control.ZoomControl']}
      >
        {points?.map((point) => {
          const {
            code,
            location: { latitude, longitude }
          } = point;

          const isSelected = selectedPoint?.code === code;

          return (
            <Placemark
              key={code}
              modules={['geoObject.addon.balloon']}
              defaultGeometry={[latitude, longitude]}
              options={{
                iconLayout: 'default#image',
                iconImageHref: isSelected ? markerSelectedIcon.src : markerIcon.src
              }}
              onClick={handleClickPoint(point)}
            />
          );
        })}
      </MapYandex>
    </YMaps>
  );
});
